import { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import trackingUserInfoAct from 'redux/actions/conversations/plugins/trackingUserInfoAct'

function usePluginTrackingUserInfo({ userId }) {
  const dispatch = useDispatch()

  const { conversations } = useSelector(store => store)
  const currentConversation = conversations[userId]

  const { isOpen, isLoading, trackingInfo, isEmpty } = currentConversation?.plugins?.trackingUserInfo || {}

  useEffect(
    () => {
      if (isOpen && userId) {
        dispatch(trackingUserInfoAct.get())
      }
    },
    [userId, isOpen]
  )

  const onClickCollapse = useCallback(
    () => {
      if (isOpen) {
        dispatch(trackingUserInfoAct.close())
      } else {
        dispatch(trackingUserInfoAct.open())
      }

    },
    [isOpen]
  )

  return {
    trackingUserInfo: trackingInfo,
    isOpen,
    isEmpty,
    isLoading,
    onClickCollapse
  }
}

export default usePluginTrackingUserInfo